import type { Event, Vehicle } from '~/types/strapi';

export default function useCustomLocaleRoute() {
  const { locale } = useI18n();
  const localeRoute = useLocaleRoute();

  const getLocaleNewsLink = (slug?: string) => {
    if (!slug) {
      return String(localeRoute({ name: 'news-events-newsSlug' }, locale.value)?.path);
    }

    return String(localeRoute({ name: 'news-events-newsSlug', params: { newsSlug: slug } }, locale.value)?.path);
  };

  const getLocaleEventLink = (title?: string) => {
    const basePath = String(localeRoute({ name: 'news-events-newsSlug' }, locale.value)?.path);
    if (!title) {
      return basePath;
    }

    const slug = useEventSlugGenerator({ title: title } as Event);

    return `${basePath}#${slug}`;
  };

  const getLocaleSearchLink = () => {
    return String(localeRoute({ name: 'autos-kaufen' }, locale.value)?.path);
  };

  const getLocaleVehicleUrl = (vehicle: Vehicle) => {
    if (!vehicle.make || !vehicle.body_style || !vehicle.slug) {
      return '';
    }

    return String(localeRoute({ name: 'autos-kaufen-make-body_style-slug', params: { make: vehicle.make.slug, body_style: vehicle.body_style[0]?.slug, slug: vehicle.slug } }, locale.value)?.path);
  };

  const getLocaleAngebotLink = (slug?: string) => {
    if (!slug) {
      return String(localeRoute({ name: 'angebote-angeboteSlug' }, locale.value)?.path);
    }

    return String(localeRoute({ name: 'angebote-angeboteSlug', params: { angeboteSlug: slug } }, locale.value)?.path);
  };

  const getLocaleFavoritesLink = () => {
    return String(localeRoute({ name: 'merkzettel' }, locale.value)?.path);
  };

  return {
    getLocaleNewsLink,
    getLocaleEventLink,
    getLocaleSearchLink,
    getLocaleVehicleUrl,
    getLocaleAngebotLink,
    getLocaleFavoritesLink,
  };
}
